<div class="row">
    <div class="col-12">
      <div class="content-header">Candidate Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
                      <h4 class="card-title">Basic</h4>
                  </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md">
                  <form [formGroup]="candidateForm">
                    <fieldset class="form-group">
                      <label for="name">Name</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="name" [(ngModel)]="candidate_model.name"
                        id="name"
                        placeholder="Enter name"
                        required
                      />
                      <div
                        *ngIf="
                          rf.name.touched &&
                          (rf.name.invalid || rf.name.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> Name is
                        required
                      </div>
                    </fieldset>
                    <fieldset  class="form-group">
                      <label>Email</label>
                        <input class="form-control input-md" formControlName="email" [(ngModel)]="candidate_model.email"
                          id="email" #email placeholder="Enter email" type="text" required />
                        <small
                            class="form-text text-muted danger"
                            *ngIf="
                              !email.valid && (email.dirty || email.touched)
                            "
                            >Email is required!</small>
                      </fieldset>
                    <fieldset  class="form-group">
                        <label>Phone</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">+91</span>
                          </div>
                          <input class="form-control input-md" formControlName="phone" [(ngModel)]="candidate_model.phone" #phone
                            id="phone" name="phone" type="text" placeholder="e.g. (555) 555 5555"
                            mask="(000) 000-0000" minlength="10"  />
                        </div>
                      </fieldset>
                      <fieldset  class="form-group">
                        <label>Notes</label>
                        <quill-editor (onContentChanged)="inlineAddupdateBody(candidate_model.notes,'notes')" [(ngModel)]="candidate_model.notes"
                        [ngModelOptions]="{standalone: true}">
                      
                      </quill-editor>
                      </fieldset>
                  </form>
                </div>
                <div class="col-md">
                  <form [formGroup]="candidateForm">
                    <fieldset class="form-group">
                      <label>Address</label>
                      <input
                        type="text"
                        class="form-control"
                        formControlName="àddress"
                        [(ngModel)]="candidate_model.address"
                        id="location"
                        placeholder="Enter address"
                      > 
                    </fieldset>
                    <!-- <fieldset class="form-group" *ngIf="candidate_id">
                      <label for="notes">Address</label>
                      <input
                        type="text"
                        (keydown.enter)="$event.preventDefault()"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="off"
                        class="form-control"
                        [(ngModel)]="address" [ngModelOptions]="{standalone: true}"
                        id="location"
                        placeholder="Enter address"
                      #search/> 
                    </fieldset> -->
                    <fieldset class="form-group">
                      <label for="jobopening">Opening</label>
                      <ng-select
                        [items]="opening_list"
                        bindLabel="title"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        [multiple]="true"
                        placeholder="Select opening"
                        [(ngModel)]="selected_opening"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getOpeningId($event)"
                        [multiple]="true"
                      >
                      </ng-select>
                    </fieldset>
                    <fieldset class="form-group">
                      <label for="notes">Experience</label>
                      <input
                        type="number" formControlName="experience" [(ngModel)]="candidate_model.experience"
                        class="form-control"
                        id="experience"
                        placeholder="Enter experience"
                      /> 
                    </fieldset>
                    <fieldset  class="form-group mt-4">
                      <label>Admin Notes</label>
                      
                      <quill-editor (onContentChanged)="inlineAddupdateBody(candidate_model.admin_notes,'admin_notes')" [(ngModel)]="candidate_model.admin_notes"
                        [ngModelOptions]="{standalone: true}">
                      </quill-editor>
                    </fieldset>
                    <div
                      class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                    >
                      <button
                        type="submit"
                        class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                        (click)="submit()"
                      >
                        Submit
                      </button>
                      <button
                        type="reset"
                        class="btn btn-secondary"
                        (click)="back()"
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
